module.exports = __webpack_public_path__ + "img/4-4.d578a97b.svg";